import React from 'react'
import Select from 'react-select'

// eslint-disable-next-line react/display-name
export default (props) => {
  // this is going to call setFieldValue and manually update values
  const handleChange = (value) => props.onChange(props.name, value)
  // this is going to call setFieldTouched and manually update touched
  const handleBlur = () => (props.onBlur ? props.onBlur(props.name, true) : '')

  const { id, label, options, value, multi, name, styles } = props
  return (
    <div className='nx-select'>
      {label && <label htmlFor={id}>{label}</label>}
      <Select
        id={id}
        name={name}
        options={options}
        isMulti={multi || false}
        onChange={handleChange}
        onBlur={handleBlur}
        value={value}
        styles={{ ...styles }}
      />
    </div>
  )
}
